import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { RuleDetailProvider } from './context/RuleDetailProvider'
import { RuleDetailWorkflowsProvider } from './context/RuleDetailWorkflowsProvider'
import { DetachJurisdictionFlowProvider } from './workflows/DetachJurisdictionFlow/context/DetachJurisdictionFlowProvider'
import { RemoveExclusionFlowProvider } from './workflows/RemoveExclusionFlow/context/RemoveExclusionFlowProvider'
import { RuleDetailMain } from './components/RuleDetailMain'
import { EditRuleFlow } from './workflows/EditRuleFlow'
import { AddRateFlow } from './workflows/AddRateFlow'
import { EditRateFlow } from './workflows/EditRateFlow'
import { AttachJurisdictionFlow } from './workflows/AttachJurisdictionFlow'
import { AddExclusionFlow } from './workflows/AddExclusionFlow'
import { DeleteRateConfirmFlow } from './workflows/DeleteRateConfirmFlow/DeleteRateConfirmFlow'

export const RuleDetail = () => {
  const ruleIdParam = useParams<{ ruleId: string }>().ruleId
  const parsedRuleId = ruleIdParam ? Number(ruleIdParam) : undefined
  const selectedRuleId = Number.isNaN(parsedRuleId) ? undefined : parsedRuleId

  if (typeof selectedRuleId === 'undefined') {
    return <Navigate to="/not-found" />
  }

  return (
    <RuleDetailProvider ruleId={selectedRuleId}>
      <RuleDetailWorkflowsProvider>
        <DetachJurisdictionFlowProvider ruleId={selectedRuleId}>
          <RemoveExclusionFlowProvider ruleId={selectedRuleId}>
            <RuleDetailMain />
            <EditRuleFlow />
            <AddRateFlow />
            <EditRateFlow />
            <AttachJurisdictionFlow />
            <AddExclusionFlow />
            <DeleteRateConfirmFlow />
          </RemoveExclusionFlowProvider>
        </DetachJurisdictionFlowProvider>
      </RuleDetailWorkflowsProvider>
    </RuleDetailProvider>
  )
}
